<template lang="pug">
  main.main
    article.product
      .product__wrap-img
        img.product__img(:src="product.PICTURE", alt='')
      .product__container
        h1.product__title {{ product.NAME }}
        h2.product__barcode {{ product.IMEI }}
        .product__days
          .product__date-buy
            | {{ $t('serviceProduct.date-buy') }}
            time {{ product.SALE_DATE }}
          template(v-if="product.GUARANTEE_PERIOD")
            .product__guaranty.product__guaranty_ok {{ $t('serviceProduct.guaranty') }}
              | {{ product.GUARANTEE_DATE }}
          template(v-else)
            .product__guaranty.product__guaranty_no {{ $t('serviceProduct.no-guaranty') }}
    .main__container
      section.service-choose
        ul.service-choose__list
          router-link.service-choose__item(tag='li', :to='{ path: `/${item.href}`}', v-for="(item, index) in $t('serviceProduct.list')", :key='index')
            a.service-choose__link
              .service-choose__img-wrap(v-html='item.icon')
              h2.service-choose__title {{ item.title }}
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ServiceProduct',
  props: ['sn'],
  created () {
    this.fetchData()
  },
  computed: {
    ...mapGetters({
      product: 'getProduct'
    })
  },
  methods: {
    fetchData () {
      this.$store.dispatch('getProduct', this.sn)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ServiceProduct.vue